import { defineMessages } from 'react-intl';

export default defineMessages({
  expandIconLabel: {
    id: 'frontbucket.repositories.jiraIssues.filterExpanderLabel',
    description: 'Label text for the expand icon on the filter.',
    defaultMessage: 'Expand',
  },
});
